import { compKey } from './key';
export var createPageContainerDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    return {
        getTitle: function () { return base.$('.page-titles .title').text(); },
        getDescription: function () { return base.$('.page-titles .description').text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map